import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';
import { getAllClosedCases } from '../../../redux/api/cases';

const ClosedCases = ({ user }) => {
    const [processing, setProcessing] = useState(false);
    const [userData, setUserData] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const [records, setRecords] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [searches, setSearches] = useState({});

    const init = async (start = 0, length = user.paginationSize) => {
        try {
            setProcessing(true);
            const res = await getAllClosedCases({ start, length, searches });
            setRecords(records?.length < start ? res?.resultObject?.data || [] : records.concat(res?.resultObject?.data || []));
            setPaginationData({
                start,
                length,
                total: res?.resultObject?.recordsTotal,
                totalFiltered: res?.resultObject?.recordsFiltered,
            });
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const exportData = async () => {
        try {
            const resp = await getAllClosedCases({ searches }, true);
            enqueueSnackbar(resp?.message || 'Your report is being processed, kindly check the reports page for progress');
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const search = async ({ skip = 0, length = 50, ...searches }) => {
        try {
            const res = await getAllClosedCases({ skip, length, searches });
            if (res?.statusCode == '000') {
                setRecords(res?.resultObject?.data || []);
                setSearches(searches);
                if (res?.resultObject?.data?.length == 0) {
                    enqueueSnackbar('No result found for search parameters', {
                        variant: 'error',
                    });
                }
            } else {
                enqueueSnackbar(res?.message || 'An error occurred', {
                    variant: 'info',
                });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        init();
    }, [user.paginationSize]);

    useEffect(() => {
        setUserData(user.userData);
    }, [user]);

    return (
        <PageContainer pageTitle="Closed Cases" processing={processing}>
            <CaseTable
                cases={records}
                initFunction={init}
                showPendingActionsBtn={false}
                showAssignBtn={false}
                showAssignFooterBtn={false}
                showCloseCaseBtn={false}
                showDeEscalateCaseBtn={false}
                showEscalateCaseBtn={false}
                showResolveCaseBtn={false}
                showReOpenFooterBtn={true}
                showReOpenCaseBtn
                exportFunction={exportData}
                searchFunction={search}
                paginationData={paginationData}
            />
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(ClosedCases);
